import { onSessionEnded } from '@/lib/api';
import { connectSocket, disconnectSocket } from '@/lib/socket';
import { useAuth } from '@/stores/auth';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Vigila el final de la sesion por dos vias:
 *
 *  - El cliente HTTP, cuando el refresh token deja de servir.
 *  - El WebSocket, que recibe `session:revoked` en el instante en que alguien
 *    inicia sesion con la misma cuenta en otro navegador. Sin esto el usuario
 *    desplazado seguiria viendo la interfaz hasta la siguiente peticion.
 */
export function useSessionWatcher(): void {
  const navigate = useNavigate();
  const user = useAuth((state) => state.user);
  const clear = useAuth((state) => state.clear);

  useEffect(() => onSessionEnded((reason) => {
    clear(reason);
    disconnectSocket();
    navigate('/login', { replace: true });
  }), [clear, navigate]);

  useEffect(() => {
    if (!user) {
      disconnectSocket();
      return;
    }

    const socket = connectSocket();
    const onRevoked = (payload: { message: string }) => {
      clear(payload.message);
      disconnectSocket();
      navigate('/login', { replace: true });
    };

    socket.on('session:revoked', onRevoked);
    return () => {
      socket.off('session:revoked', onRevoked);
    };
  }, [user, clear, navigate]);
}
